module.exports = __webpack_public_path__ + "img/que-es-medika.31c0e1e6.png";